// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `i[class^=icon] {
  font-size: 15px;
}

.main-operations .btn-sm {
  padding: 0 8px !important;
  margin: 0 !important;
}

.editDropdown {
  padding: 0 !important;
  top: -11px !important;
}

.editDropdown .dropdown-item {
  padding: 5px 10px !important;
}

.newheading {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/app/common/header/header.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI,yBAAA;EACA,oBAAA;AAEJ;;AAAA;EACI,qBAAA;EACA,qBAAA;AAGJ;;AADA;EACI,4BAAA;AAIJ;;AAFA;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;AAKJ","sourcesContent":["i[class^=\"icon\"] {\r\n    font-size: 15px;\r\n}\r\n.main-operations .btn-sm{\r\n    padding: 0 8px !important;\r\n    margin: 0 !important;\r\n}\r\n.editDropdown{\r\n    padding: 0 !important;\r\n    top: -11px !important;\r\n}\r\n.editDropdown .dropdown-item{\r\n    padding: 5px 10px !important;\r\n}\r\n.newheading{\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
